import React from 'react';
import { CaptureItem } from '../types';

interface FolderTreeProps {
  node: CaptureItem;
  depth?: number;
  expandedFolders: Set<string>;
  selectedFolderPath: string;
  onToggleFolder: (folderId: string) => void;
  onFolderClick: (folder: CaptureItem) => void;
}

const FolderTree: React.FC<FolderTreeProps> = ({
  node,
  depth = 0,
  expandedFolders,
  selectedFolderPath,
  onToggleFolder,
  onFolderClick,
}) => {
  if (node.type !== 'folder') return null;
  
  const isExpanded = expandedFolders.has(node.id);
  const isSelected = node.path === selectedFolderPath || (node.id === 'root' && !selectedFolderPath);
  
  return (
    <div key={node.id}>
      <button
        onClick={() => {
          onToggleFolder(node.id);
          onFolderClick(node);
        }}
        className={`w-full flex items-center space-x-2 px-2 py-1.5 rounded-lg text-sm ${
          isSelected ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700 hover:bg-gray-50'
        }`}
        style={{ paddingLeft: `${depth * 12 + 8}px` }}
      >
        <span className="text-xs">{isExpanded && node.children && node.children.length > 0 ? '▾' : '▸'}</span>
      <span className="text-base">📁</span>
        <span>{node.name}</span>
      </button>
      {isExpanded && node.children && node.children.length > 0 && (
        <div className="space-y-1 mt-1">
          {node.children
            .filter((child) => child.type === 'folder')
            .map((child) => (
              <FolderTree
                key={child.id}
                node={child}
                depth={depth + 1}
                expandedFolders={expandedFolders}
                selectedFolderPath={selectedFolderPath}
                onToggleFolder={onToggleFolder}
                onFolderClick={onFolderClick}
              />
            ))}
        </div>
      )}
    </div>
  );
};

export default FolderTree;

